import '../../CommonStyles.scss';
import KpiCard from '../../components/KpiCard/KpiCard';
import { KpiDelta, KpiMeta } from '../../components/KpiCard/KpiMeta';
import { useGetCertificationUserCounts, useGetActiveSubscriptionsKpi } from 'queryHooks/analytics';
import { NoData } from '../../components/NoData/NoData';

export const OverviewTab = () => {
  const { data: certUserCounts, isLoading: certCountsLoading, isError: certCountsError } = useGetCertificationUserCounts();

  return (
    <div className='analytics-tab'>
      <div className='overview-section'>
        <div className='section-grid metrics'>
          <ActiveSubscriptionsCard />
          <AutoRenewOnCard />
        </div>
      </div>
      {certCountsError || certCountsLoading || !certUserCounts?.length ? (
        <NoData loading={certCountsLoading} error={certCountsError} noData={!certUserCounts?.length} />
      ) : (
        <div className='overview-section'>
          <div className='section-grid metrics'>
            {certUserCounts?.map((c) => (
              <KpiCard key={c.certificationId} label={c.title} source='DB' value={c.userCount} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const ActiveSubscriptionsCard = () => {
  const { data: activeSubsKpi } = useGetActiveSubscriptionsKpi();
  return (
    <KpiCard label='Active Subscriptions' source='RECURLY' value={activeSubsKpi?.activeSubscriptions ?? '—'}>
      {activeSubsKpi?.changePercent != null && <KpiDelta value={activeSubsKpi.changePercent} suffix='vs prev month' />}
    </KpiCard>
  );
};

const AutoRenewOnCard = () => {
  const { data: activeSubsKpi } = useGetActiveSubscriptionsKpi();
  return (
    <KpiCard label='Auto-Renew ON' source='RECURLY' value={activeSubsKpi?.renewingSubscriptions ?? '—'}>
      {activeSubsKpi?.renewingSubscriptionsPercent != null && (
        <KpiMeta tone='positive'>{activeSubsKpi.renewingSubscriptionsPercent.toFixed(1)}% of active</KpiMeta>
      )}
    </KpiCard>
  );
};

export default OverviewTab;
